import { ADVISOR_SEARCH_PAGE_SIZE } from '@ria-client/advisor-search/types';

export type LoadingSkeletonProps = {
  count?: number;
};

export function LoadingSkeleton({ count = ADVISOR_SEARCH_PAGE_SIZE }: LoadingSkeletonProps) {
  return (
    <div
      aria-busy="true"
      aria-live="polite"
      data-testid="advisor-results-loading"
      className="flex flex-col"
    >
      <div
        aria-hidden="true"
        data-testid="advisor-results-header-skeleton"
        className="my-6 h-5 w-80 animate-pulse bg-muted"
      />
      <div className="flex flex-col gap-4">
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            aria-hidden="true"
            data-testid="advisor-skeleton"
            className="h-[220px] animate-pulse rounded-callout bg-muted"
          />
        ))}
      </div>
    </div>
  );
}
